<script>
import All from '../transaction/all'
export default {
  props: {
    user: Object
  },
  components: {
    All
  },
  data() {
    return {

    }
  },
  mounted() {
  },
  methods: {

  }
};
</script>

<template>
  <div>
    <All :user="user" :search-by-user="true" />
  </div>
</template>
